export default __webpack_public_path__ + "static/media/15th Finance Commission Letter 20 February 2020.c483472e.pdf";